import { isEmpty, isNullOrUndefined } from "../matchers/matchers.js";
//#region src/utils/redux/state-utils.ts
var onFulfilled = (state, action) => {
	const pending = isNullOrUndefined(state?.pending?.length) ? [] : state.pending.filter((id) => id !== action.meta.requestId);
	state.errorMessage = "";
	state.isPending = pending.length > 0;
	state.isRejected = false;
	if (!isEmpty(pending)) state.pending = pending;
	else delete state.pending;
};
var onPending = (state, action) => {
	const pending = !isNullOrUndefined(state?.pending?.length) ? [...state.pending, action.meta.requestId] : [action.meta.requestId];
	state.isPending = pending.length > 0;
	state.isRejected = false;
	if (!isEmpty(pending)) state.pending = pending;
	else delete state.pending;
};
var onRejected = (state, action) => {
	const pending = isNullOrUndefined(state?.pending?.length) ? [] : state.pending.filter((id) => id !== action.meta.requestId);
	state.errorMessage = !isEmpty(action.error.message) ? action.error.message : action.error.name;
	state.errorType = action.error.code;
	state.isPending = pending.length > 0;
	state.isRejected = true;
	if (!isEmpty(pending)) state.pending = pending;
	else delete state.pending;
};
//#endregion
export { onFulfilled, onPending, onRejected };

//# sourceMappingURL=state-utils.js.map